"use strict";

exports.__esModule = true;
exports.default = exports.getRandomApp = void 0;

var _app = _interopRequireDefault(require("../data/app.finder"));

var _app2 = _interopRequireDefault(require("../data/app.dashboard"));

var _app3 = _interopRequireDefault(require("../data/app.analytics"));

var _app4 = _interopRequireDefault(require("../data/app.inbox"));

var _app5 = _interopRequireDefault(require("../data/app.primus"));

var _app6 = _interopRequireDefault(require("../data/app.m24"));

var _app7 = _interopRequireDefault(require("../data/app.dm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const apps = [_app.default, _app2.default, _app3.default, _app4.default, _app5.default, _app6.default, _app7.default];

const getRandomArrayItem = array => {
  const r = Math.floor(Math.random() * Math.floor(array.length));
  return array[r];
};

const getRandomApp = () => {
  return getRandomArrayItem(apps);
};

exports.getRandomApp = getRandomApp;
var _default = getRandomApp;
exports.default = _default;